import React from "react";
import { Helmet } from "react-helmet-async";
import GallerySection from "../components/gallery/GallerySection";

const Gallery = () => {
  return (
    <div className="flex flex-col pt-16 md:pt-20 bg-[#f5f5f5]">
      <Helmet>
        <title>Reflection Futbol Academy | Gallery</title>
        <meta
          name="description"
          content="Browse photos and videos from Reflection Futbol Academy training sessions, matchday moments, and academy life."
        />
        <link
          rel="canonical"
          href="https://reflectionfutbolacademy.com/gallery"
        />
        <meta
          property="og:title"
          content="Gallery | Reflection Futbol Academy"
        />
        <meta
          property="og:description"
          content="See academy moments from the pitch through a mix of photos and videos."
        />
      </Helmet>

      <section className="relative py-12 md:py-20 bg-[#7D192A] flex items-center justify-center text-center overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <img
            src="/gallery/g2.webp"
            alt="Reflection Futbol Academy gallery hero"
            className="w-full h-full object-cover"
            fetchPriority="high"
          />
        </div>
        <div className="relative z-10 w-full max-w-7xl mx-auto site-gutter">
          <h1 className="page-hero-title text-white uppercase">Gallery</h1>
          <div className="mt-3 md:mt-4 h-1 w-16 md:h-2 md:w-32 bg-[#F4B400] mx-auto rounded-full" />
        </div>
      </section>

      <GallerySection
        title="From Training To Matchday"
        eyebrow="Academy Media"
        intro="A curated look at how Reflection Futbol Academy trains, competes, and builds confident players."
      />
    </div>
  );
};

export default Gallery;
